import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function ConfirmationDialog({ booking, onClose }) {
  const open = !!booking;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent
        data-testid="booking-confirmation-dialog"
        className="rounded-[32px] max-w-md p-10 bg-background border-border/60"
      >
        <div className="text-center">
          <div className="mx-auto w-20 h-20 rounded-full bg-primary/40 flex items-center justify-center check-circle">
            <svg width="40" height="40" viewBox="0 0 50 50" fill="none">
              <path
                d="M14 26 L22 34 L37 18"
                stroke="hsl(var(--foreground))"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="check-path"
              />
            </svg>
          </div>
          <DialogTitle className="font-serif text-3xl mt-6">Your session is reserved</DialogTitle>
          <DialogDescription className="text-muted-foreground mt-2">
            Thank you, {booking?.name?.split(" ")[0]}. A confirmation has been sent to{" "}
            <span className="text-foreground">{booking?.email}</span>.
          </DialogDescription>

          {booking && (
            <div className="mt-6 text-left rounded-2xl bg-card/60 border border-border/60 p-5 space-y-2 text-sm">
              <Row k="Service" v={booking.service_name} />
              <Row k="Date" v={`${booking.preferred_date} · ${booking.preferred_time}`} />
              <Row k="Location" v={booking.address} />
              <Row k="Payment" v={booking.payment_option === "pay_now" ? "Paid" : "After session"} />
            </div>
          )}

          <p className="text-xs text-muted-foreground mt-5">
            Payment can be completed after your session.
          </p>

          <Button onClick={onClose} data-testid="confirmation-close-btn" className="mt-7 rounded-full px-10 bg-foreground text-background hover:bg-foreground/85">
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex justify-between gap-3">
      <span className="text-muted-foreground">{k}</span>
      <span className="text-foreground text-right">{v}</span>
    </div>
  );
}
